import { breakpoints } from '@/utils/util-breakpoints';
import styled from 'styled-components';

export const CompressorRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: transparent;
  border-radius: 8px;
  box-shadow: none;

  .compressor-field-manufacturer-type {
    width: 100%;
  }

  .compressor-row-content {
    display: grid;
    grid-template-columns: 65px 1fr 1fr 1fr 1fr 32px 32px;
    column-gap: ${({ theme: { token } }) => token.margin}px;
    align-items: center;
    width: 100%;

    grid-template-areas:
      'number serial model modelSpec controller update delete'
      'tags tags tags tags tags tags tags';

    .compressor-field,
    .model-spec-select {
      margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
    }

    > .compressor-field {
      display: flex;
      flex-direction: column;
      gap: ${({ theme: { token } }) => token.marginXXS}px;
      align-self: flex-start;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .compressor-field-images {
      grid-area: tags;

      .ant-form-item {
        margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .compressor-tags-list {
        display: flex;
        flex-direction: row;
        gap: ${({ theme: { token } }) => token.marginSM}px;
        flex-wrap: wrap;
        .ant-btn {
          color: ${({ theme: { token } }) => token.colorPrimary};
          .ant-btn-icon {
            color: ${({ theme: { token } }) => token.colorIcon};
          }
        }
      }
    }

    @media (max-width: ${breakpoints.lg - 1}px) {
      grid-template-columns: 65px 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-template-areas:
        'number serial serial serial model model model'
        'number modelSpec modelSpec modelSpec controller controller controller'
        '. tags tags tags tags tags tags'
        '. upload upload delete delete . .';
      gap: ${({ theme: { token } }) => token.marginSM}px;
      row-gap: 0;

      > .compressor-field {
        &:nth-of-type(1) {
          grid-area: number;
        }
        &:nth-of-type(2) {
          grid-area: serial;
        }
        &:nth-of-type(3) {
          grid-area: model;
        }
        &:nth-of-type(4) {
          grid-area: modelSpec;
        }
        &:nth-of-type(5) {
          grid-area: controller;
        }
        &:nth-of-type(6) {
          grid-area: upload;
        }
        &:nth-of-type(7) {
          grid-area: delete;
        }
      }
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      grid-template-columns: 65px 1fr;
      grid-template-areas:
        'number serial'
        'model model'
        'modelSpec modelSpec'
        'controller controller'
        'tags tags'
        'upload upload'
        'delete delete';
      gap: ${({ theme: { token } }) => token.marginXS}px;
      row-gap: 0;

      > .compressor-field {
        &:nth-of-type(1) {
          grid-area: number;
          width: 80px;
        }
        &:nth-of-type(2) {
          grid-area: serial;
          width: 100%;
        }
        &:nth-of-type(3) {
          grid-area: model;
        }
        &:nth-of-type(4) {
          grid-area: modelSpec;
        }
        &:nth-of-type(5) {
          grid-area: controller;
        }
        &:nth-of-type(6) {
          grid-area: upload;
          margin-top: ${({ theme: { token } }) => token.marginXS}px;
        }
        &:nth-of-type(7) {
          grid-area: delete;
          margin-top: ${({ theme: { token } }) => token.marginXS}px;
        }
      }
    }
  }

  .compressor-action-button {
    font-size: ${props => props.theme.token.fontSize};
    font-weight: ${props => props.theme.token.fontWeight};
    line-height: ${props => props.theme.token.lineHeight};
  }

  .compressor-input {
    width: 100%;
  }

  .compressor-label {
    color: ${props => props.theme.token.colorTextSecondary};
    font-size: ${props => props.theme.token.fontSize};
    font-style: normal;
    font-weight: ${props => props.theme.token.fontWeightNormal};
    line-height: ${props => props.theme.token.lineHeight};
    margin-bottom: ${props => props.theme.token.marginXXS}px;
  }
`;